import toast from "react-hot-toast";
import { baseUrl } from "./baseUrl";

export async function updateUserKyc(
  userId: string,
  kycStatus: "Success" | "Pending" | "Failed" | "YetToStart" | "Issued"
): Promise<void> {
  console.log(userId, kycStatus);
  const token = sessionStorage.getItem("admin_token");
  try {
    const res = await fetch(
      `${baseUrl}/admin/users/kyc/${encodeURIComponent(userId)}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ kycStatus }),
      }
    );

    if (!res.ok) {
      const errJson = await res.json().catch(() => null);
      const msg = errJson?.message?.toLowerCase?.() ?? "";
      // handle auth errors uniformly
      if (["invalid token", "jwt malformed", "jwt expired"].includes(msg)) {
        sessionStorage.removeItem("admin_token");
        toast.error("Session expired — please log in again.");
        window.location.href = "/auth/sign-in";
        return Promise.reject(new Error("Unauthorized"));
      }
      throw new Error(errJson?.message ?? `HTTP ${res.status}`);
    }

    toast.success("KYC status updated successfully");
  } catch (error) {
    console.error("Error updating KYC status:", (error as Error).message);
    toast.error(`Update failed: ${(error as Error).message}`);
    throw error;
  }
}
